import SvgIcon from "./IconDocument.svg?react";
const IconDocument = SvgIcon;
export default IconDocument;
